import { Component, OnInit, } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, OnDestroy, ViewChild, TemplateRef, ElementRef } from '@angular/core';

import { AlertService, AuthenticationService } from '../../servicio';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { BnNgIdleService } from 'bn-ng-idle';
import Keyboard from "simple-keyboard";
import { ControlContainer } from '@angular/forms';
import { UserIdleService } from 'angular-user-idle';
import { NgbModal, NgbModalConfig, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Title } from '@angular/platform-browser';
import { Servicio } from '../../servicio/servicio';
import { Var_menu } from '../../variable_globales/ver_menu';
//import { Socket } from 'ngx-socket-io';
import { filter, map } from 'rxjs/operators';

import { Info_operacion } from '../../variable_globales/info_operacion';

import { CdkScrollable } from '@angular/cdk/scrolling';

import { Notificacion } from '../../modelo/notificacion';

import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
export interface Menu {

  titulo: string;
  url: String;
  estado: boolean;
  submenu: Menu[];
  tipo: number;
}
export interface Section {
  name: string;
  updated: Date;
}

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css', "../../../../node_modules/simple-keyboard/build/css/index.css",],
  providers: [NgbModalConfig, NgbModal],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})


export class LayoutComponent implements OnInit {
  @ViewChild(CdkScrollable, { static: true }) scrollable: CdkScrollable;
  myDrop: NgbDropdown;
  date: Date;
  listanotificacion: Notificacion[] = [
    /*{
      datos:{id: "01-101-084010000841", nombre_producto: "Aporte Soles",
      cuenta_producto: "01-101-084010000841", monto_contable: "20392.00",
      monto_disponible: "20392.00",

      tea: ".0000",
      trea: ".0000"},
      descripcion:"Jimmy Jeiensto acaba de depositar",
      fecha:"2021-07-09 14:03:12",
      id:"1",
      url:"/inicio/ahorro",
      titulo:"Se ingreso un nuevo pago "
    },
    {
      datos:{},
      descripcion:"Jimmy Jeiensto acaba de depositar",
      fecha:"2021-07-09 14:03:12",
      id:"1",
      url:"/inicio/ahorro",
      titulo:"Se ingreso un nuevo pago "
    },
    {
      datos:{},
      descripcion:"Jimmy Jeiensto acaba de depositar",
      fecha:"2021-07-09 14:03:12",
      id:"1",
      url:"/inicio/ahorro",
      titulo:"Se ingreso un nuevo pago "
    },
    {
      datos:{id: "01-101-084010000841", nombre_producto: "Aporte Soles",
                    cuenta_producto: "01-101-084010000841", monto_contable: "20392.00",
                    monto_disponible: "20392.00",

                    tea: ".0000",
                    trea: ".0000"},
      descripcion:"Jimmy Jeiensto acaba de depositar",
      fecha:"2021-07-09 14:03:12",
      id:"1",
      url:"/inicio/ahorro",
      titulo:"Se ingreso un nuevo pago "
    }
    ,  {
      datos:{id: "01-101-084010000841", nombre_producto: "Aporte Soles",
      cuenta_producto: "01-101-084010000841", monto_contable: "20392.00",
      monto_disponible: "20392.00",

      tea: ".0000",
      trea: ".0000"},
      descripcion:"Jimmy Jeiensto acaba de depositar",
      fecha:"2021-07-09 14:03:12",
      id:"1",
      url:"/inicio/ahorro",
      titulo:"Se ingreso un nuevo pago "
    }
    ,  {
      datos:{id: "01-101-084010000841", nombre_producto: "Aporte Soles",
      cuenta_producto: "01-101-084010000841", monto_contable: "20392.00",
      monto_disponible: "20392.00",

      tea: ".0000",
      trea: ".0000"},
      descripcion:"Jimmy Jeiensto acaba de depositar",
      fecha:"2021-07-09 14:03:12",
      id:"1",
      url:"/inicio/ahorro",
      titulo:"Se ingreso un nuevo pago "
    }
    ,  {
      datos:{id: "01-101-084010000841", nombre_producto: "Aporte Soles",
      cuenta_producto: "01-101-084010000841", monto_contable: "20392.00",
      monto_disponible: "20392.00",

      tea: ".0000",
      trea: ".0000"},
      descripcion:"Jimmy Jeiensto acaba de depositar",
      fecha:"2021-07-09 14:03:12",
      id:"1",
      url:"/inicio/ahorro",
      titulo:"Se ingreso un nuevo pago "
    }*/

  ];
  onActivate(e, outlet) {
    outlet.scrollTop = 0;
  }
  redireccionar(url: string, data: any) {
    console.log(data);
    /// this.myDrop.close();
    this.router.navigateByUrl(url, { state: data });
  }


  onSideNavScroll(event) {
    // alert();
    event.stopPropagation()
  }

  numero_notificaciones = this.listanotificacion.length;
  lista_menu: Menu[] = [

  ];
  mostrar_menulateral = true;
  open_mas = false;
  open_vota = false;
  open_ope = false;

  abrir(i) {
    this.lista_menu[i].estado = true;

  }
  cerrar(i) {
    this.lista_menu[i].estado = false;
  }
  constructor(
    public loader: NgxUiLoaderService,
    //private socket:Socket,
    private servicio: Servicio,
    private titleService: Title,
    public activeModal: NgbActiveModal, private userIdle: UserIdleService,
    private modalService: NgbModal, private bnIdle: BnNgIdleService,
    public router: Router, public changeDetectorRef: ChangeDetectorRef, public media: MediaMatcher,
    public authenticationService: AuthenticationService,
    public varglobal: Var_menu,
    public info: Info_operacion
  ) {


    this.date = new Date();


  }

  mostrar_modal() {

  }


  cargar_menu() {

    let _this = this;
    var mostrar = this.authenticationService.currentUserValue;
    var token = mostrar["token"];
    let request = {};
    request["cuenta"] = mostrar["cuenta"];
    if (mostrar["votacion"] == 0) {
      this.servicio.enviar_seguro("api/ws_cargar_menu", request, token).pipe().subscribe(
        response => {
          //    console.log(response["response"]["menu"]);
          let menu1 = response["response"]["menu"];
          _this.lista_menu = menu1;
          _this.varglobal.updateSharedData(response["response"]["estado_menu"]);
        }, error => {

        });
    } else {
      this.mostrar_menulateral = false;
    }
  }








  options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 0
  };

  success(pos) {
    var crd = pos.coords;

    // console.log('Your current position is:');
    // console.log('Latitude : ' + crd.latitude);
    // console.log('Longitude: ' + crd.longitude);
    //console.log('More or less ' + crd.accuracy + ' meters.');
  };

  error(err) {
    console.warn('ERROR(' + err.code + '): ' + err.message);
  };









  async abrir_socket() {

    let tipo = 1;
    let _this = this;
    const getCoords = async () => {

      let pos: any = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      }).catch((error) => {
        console.log(error);
        tipo = 0;
      });
      if (tipo == 1) {
        return {
          long: pos.coords.longitude,
          lat: pos.coords.latitude,
          tipo_ubicacion: 1
        };
      } else {
        return {
          long: 0,
          lat: 0,
          tipo_ubicacion: 0
        };

      }

    };

    const coords = await getCoords();

    var mostrar = this.authenticationService.currentUserValue;
    // var =mostrar["token"];

    var aKeys = ["MSIE", "Firefox", "Safari", "Chrome", "Opera"],
      sUsrAg = navigator.userAgent, nIdx = aKeys.length - 1;

    var Name = "Not known";
    if (window.navigator.userAgent.indexOf("Windows NT 10.0") != -1) Name = "Windows 10";
    if (window.navigator.userAgent.indexOf("Windows NT 6.2") != -1) Name = "Windows 8";
    if (window.navigator.userAgent.indexOf("Windows NT 6.1") != -1) Name = "Windows 7";
    if (window.navigator.userAgent.indexOf("Windows NT 6.0") != -1) Name = "Windows Vista";
    if (window.navigator.userAgent.indexOf("Windows NT 5.1") != -1) Name = "Windows XP";
    if (window.navigator.userAgent.indexOf("Windows NT 5.0") != -1) Name = "Windows 2000";
    if (window.navigator.userAgent.indexOf("Mac") != -1) Name = "Mac/iOS";
    if (window.navigator.userAgent.indexOf("X11") != -1) Name = "UNIX";
    if (window.navigator.userAgent.indexOf("Linux") != -1) Name = "Linux";

    for (nIdx; nIdx > -1 && sUsrAg.indexOf(aKeys[nIdx]) === -1; nIdx--);

    let request = {};
    request["cuenta"] = mostrar["cuenta"];
    request["nombre"] = mostrar["nombre"];
    request["apellido"] = mostrar["apellido"];
    request["estado_ubicacion"] = coords.tipo_ubicacion;
    request["latitud"] = coords.lat;
    request["longitud"] = coords.long;
    request["tipo_dispositivo"] = "1";
    request["informacion_dispositivo"] = Name + "-" + aKeys[nIdx];
    request["informacion_adicional"] = {};

    this.info.updateSharedData(request);
    console.log(request);
    //this.socket.emit("iniciar_sesion", request);
    console.log(coords);
  }





  ngOnInit() {


    //this.abrir_socket() ;

    var mostrar = this.authenticationService.currentUserValue;
    this.nombre = mostrar["nombre"];
    this.mobileQuery = this.media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.mobileQuery.addListener(this.cambios);
    if (this.mobileQuery.matches) {
      this.opened = false;
      this.open_barra = false;
      this.movil = true;
    } else {
      this.opened = false;
      this.open_barra = false;
      this.movil = false;
    }
    this.mobileQuery.removeListener(this._mobileQueryListener);

    /* this.bnIdle.startWatching(120).subscribe((isTimedOut: boolean) => {
      if(isTimedOut){
       this.salir();
       this.bnIdle.stopTimer();
      }
     });*/
    var _this = this;
    this.userIdle.startWatching();
    this.cargar_menu();
    //console.log();
    // Start watching when user idle is starting.
    this.userIdle.onTimerStart().subscribe(count => {
      // console.log(count);
      if (count == 1) {
        _this.open();
        this.valor -= 1;
      } else {
        this.valor -= 1;

      }
    });

    // Start watch when time is up.

    this.userIdle.onTimeout().subscribe(() => {
      _this.salir();
    });


    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      document.querySelector('.mat-sidenav-content').scrollTop = 0;
    });

  }




  @ViewChild('content', { static: false }) content: TemplateRef<any>;
  showFiller = false;
  modalRef: NgbModalRef;
  mobileQuery: MediaQueryList;
  opened: boolean;
  open_barra: boolean;
  movil: boolean;
  private _mobileQueryListener: () => void;
  nombre;
  valor = 11;
  onResize(event) {

  }

  ngAfterContentInit() {
  }



  ControlContainer(ruta, titulo) {
    this.opened = false;
    this.router.navigate([ruta]);
    this.setTitle(titulo);
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
  open() {
    this.modalRef = this.modalService.open(this.content, { ariaLabelledBy: 'modal-basic-title', backdrop: 'static', keyboard: false, centered: true });
    this.modalRef.result.then((e) => {
    });
  }
  cambios() {
  }

  ngOnDestroy(): void {
  }
  salir() {

    var _this = this;
     _this.userIdle.stopTimer();
          _this.authenticationService.logout();
          _this.modalService.dismissAll();
            location.reload();
    /*let request = {};
    var mostrar = this.authenticationService.currentUserValue;
    request["cuenta"] = mostrar["cuenta"];


    var token = mostrar["token"];
    this.loader.start();
    this.servicio.enviar_seguro("api/ws_login_close", request, token).pipe().subscribe(
      response => {

        if (response["status"] == 200) {
          _this.userIdle.stopTimer();
          _this.authenticationService.logout();
          _this.modalService.dismissAll();
          location.reload();
          _this.router.navigate(['/login']);
        }
      });*/
  }
  retieme() {
    this.valor = 11;
    this.modalRef.close();
    this.userIdle.resetTimer();

  }




}
